import {FC} from 'react'
import {SidebarMenuItem} from './SidebarMenuItem'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {useOpenPortalTicketsCount} from '../../../../../app/modules/client-portal-tickets/useOpenPortalTicketsCount'
import './PortalCustomerMenu.css'

// Menu "Portal do Cliente" (só gestores/admins): mostra um alerta vermelho enquanto houver
// tickets abertos e some quando a lista de abertos estiver vazia.
const PortalCustomerMenu: FC = () => {
  const openTickets = useOpenPortalTicketsCount()
  const label = `${openTickets} ${openTickets === 1 ? 'ticket aberto' : 'tickets abertos'}`

  return (
    <SidebarMenuItemWithSub
      to='#'
      title='Portal do Cliente'
      fontIcon='bi-headset'
      badge={
        openTickets > 0 ? (
          <span
            className='portal-tickets-badge portal-tickets-badge-blink'
            role='status'
            title={label}
          >
            <span className='visually-hidden'>{label}</span>
            <span aria-hidden='true'>{openTickets}</span>
          </span>
        ) : null
      }
    >
      <SidebarMenuItem
        to='/client-portal-tickets'
        title='Tickets'
        hasBullet={true}
        badge={
          openTickets > 0 ? (
            <span className='portal-tickets-badge' title={label}>
              {openTickets}
            </span>
          ) : null
        }
      />
      <SidebarMenuItem to='/admin/client-portal-access' title='Acessos' hasBullet={true} />
    </SidebarMenuItemWithSub>
  )
}

export {PortalCustomerMenu}
